import React from 'react';
import TablaImpuesto1 from '../components/impuesto1x500/tablaIpm1x500';

function Impuestox() {
  return (
 
 <div className='col-sm-12 d-flex justify-content-center row p-0 m-0'>
            <TablaImpuesto1/>
        </div>
  );
}

export default Impuestox;




// WEBPACK FOOTER //
// ./src/pages/impuestox500.js